import {InjectionToken} from '@angular/core';
import {IziviaThemeEnvironment} from '../domain/environment/iziviaMobileEnvironment';

export const IZIVIA_ENVIRONMENTS = new InjectionToken<IziviaThemeEnvironment[]>('Environments usable by application');
export const IZIVIA_DEFAULT_ENVIRONMENT = new InjectionToken<IziviaThemeEnvironment>('Default environment');
